import script from "./TxDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TxDetails.vue?vue&type=script&setup=true&lang=js"

import "./TxDetails.vue?vue&type=style&index=0&id=70ac0862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ac0862"]])

export default __exports__